var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('line-chart',{attrs:{"data":_vm.gdata,"discrete":true,"ytitle":"Total Scores","download":{ background: 'white' },"xtitle":"Attempts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }